export const permissionsData = [
    {
        category: 'Products',
        actions: [
            {
                label: 'View',
                routes: [
                    { route: '/products', method: 'GET' },
                    { route: '/product-categories', method: 'GET' },
                     { route: '/editor-template', method: 'GET' }
                ],
            },
            {
                label: 'Add/Edit',
                routes: [
                    { route: '/products', method: 'POST' },
                    { route: '/product-categories', method: 'POST' },
                    { route: '/uploads', method: 'POST' },
                    { route: '/generate-pdf', method: 'GET' },
                    { route: '/editor-template', method: 'POST' }
                ],
            },
            {
                label: 'Delete',
                routes: [
                    { route: '/products', method: 'DELETE' },
                    { route: '/editor-template', method: 'DELETE' }
                ],
            }
        ]
    },
    {
        category: 'Inventory',
        actions: [
            {
                label: 'View',
                routes: [{ route: '/inventory', method: 'GET' }],
            },
            {
                label: 'Add/Edit',
                routes: [{ route: '/products/:id/variants', method: 'POST' }],
            }
        ]
    },
    {
        category: 'Thermofisher',
        actions: [
            {
                label: 'View',
                routes: [{ route: '/thermofisher', method: 'GET' }],
            },
            {
                label: 'Add/Edit',
                routes: [{ route: '/products/:id/metadata', method: 'POST' }],
            }
        ]
    },
    {
        category: 'Analytics',
        actions: [
            {
                label: 'View',
                routes: [{ route: '/analytics', method: 'GET' }],
            }
        ]
    },
    {
        category: 'Orders',
        actions: [
            {
                label: 'View',
                routes: [{ route: '/orders', method: 'GET' }],
            },
            {
                label: 'Order Accept',
                routes: [{ route: '/orders/:id/capture', method: 'POST' }],
            },
            {
                label: 'Order Shipment',
                routes: [
                    { route: '/orders/:id/shipment', method: 'POST' },
                    { route: '/orders/:id/fulfillment', method: 'DELETE' }
                ],
            },
            {
                label: 'Order Complete',
                routes: [{ route: '/orders/:id/complete', method: 'POST' }],
            },
        ]
    },
    {
        category: 'Customers',
        actions: [
            {
                label: 'View',
                routes: [
                    { route: '/customers', method: 'GET' },
                    { route: '/customer-groups', method: 'GET' },
                    { route: '/customer-groups/:id/customers', method: 'GET' }
                ],
            }
        ]
    },
    {
        category: 'Teams',
        actions: [
            {
                label: 'View',
                routes: [
                    { route: '/teams', method: 'GET' },
                    { route: '/team', method: 'GET' }
                ]
            },
            {
                label: 'Add/Edit',
                routes: [
                    { route: '/teams', method: 'POST' },
                    { route: '/team', method: 'POST' },
                    { route: 'update-team', method: 'POST' },
                    { route: '/uploads', method: 'POST' }
                ]
            },
            {
                label: 'Delete',
                routes: [
                    { route: '/team', method: 'DELETE' }
                ]
            }
        ]
    },
    {
        category: 'Admins',
        actions: [
            {
                label: 'View Admins',
                routes: [{ route: '/users', method: 'GET' }],
            },
            {
                label: 'Add/Edit Admins',
                routes: [{ route: '/users', method: 'POST' }],
            },
            {
                label: 'Reset Password Admins',
                routes: [
                    { route: '/users/reset-password', method: 'POST' },
                    { route: '/users/password-token', method: 'POST' }
                ],
            },
            {
                label: 'View Role',
                routes: [{ route: '/roles', method: 'GET' }],  
            },
            {
                label: 'Add/Edit Role',
                routes: [
                    { route: '/roles', method: 'POST' },
                    { route: '/permissions', method: 'POST' }
                ],
            },
            {
                label: 'Change User Role ',
                routes: [{ route: '/role/:id/user/:id', method: 'POST' }],
            },
            {
                label: 'Delete',
                routes: [{ route: '/users', method: 'DELETE' }],
            },
        ]
    }
];  
export const mapPermissionsToLabels = (metadata) => {
    const output = [];

    permissionsData.forEach(category => {
      const enabledLabels = [];

      category.actions.forEach(action => {
        const allMatched = action.routes.every(({ route, method }) =>
          metadata?.[route]?.[method] === true
        );

        if (allMatched) {
          enabledLabels.push(action.label);
        }
      });

      if (enabledLabels.length > 0) {
        output.push({
          category: category.category,
          labels: enabledLabels
        });
      }
    });

    return output;
}

export const hasPermission = (metadata, routes, methods, user_id) => {
  if (!user_id) return false;
  if (!metadata) return true;
  const routesArray = Array.isArray(routes) ? routes : [routes];
  const methodsArray = Array.isArray(methods) ? methods : [methods];

  for (let route of routesArray) {
    if (!metadata[route]) return false;

    for (let method of methodsArray) {
      if (metadata[route][method] !== true) return false;
    }
  }

  return true;
}

export const isAvailableRoute = (metadata, route, method, user_id) => {
  if (!user_id) return false;
  if (!metadata || !route) return false;

  if (metadata[route] && metadata[route][method] === true) {
    return true;
  }

  for (let availableRoute in metadata) {
    if (metadata[availableRoute][method] === true) {
      return availableRoute;
    }
  }

  return '/products/primary-antibodies'
}
